import React from "react";
import Stars from "./Stars";
import { TrustPilotReview } from "./TrustPilotTypes";
import { RegexUtils } from "@/shared/utils/RegexUtils";

interface BreedTrustPilotCardProps extends TrustPilotReview {
    boldTerms?: string[];
}

export const BreedTrustPilotCard = ({ review, name, stars, boldTerms }: BreedTrustPilotCardProps) => {
    return (
        <div className="flex h-full w-[220px] flex-col gap-4 overflow-hidden rounded-xl bg-background-primary p-4 text-left">
            <div className="flex flex-col gap-2">
                <Stars stars={stars} />
                <p className="line-clamp-5 text-xs font-medium leading-4 text-content-secondary">{boldTerms?.length ? highlightTerms(review, boldTerms) : review}</p>
            </div>
            <div className="mt-auto">
                <p className="text-xs font-bold leading-4 text-content-primary">{name}</p>
            </div>
        </div>
    );
};

function highlightTerms(text: string, terms: string[]): React.ReactNode[] {
    // Callers must pass `terms` longest-first; alternation picks the first alt that matches at each position,
    // so "Labrador Retriever" wins over "Labrador" wins over "Lab" without partial-word highlights.
    const pattern = terms.map(RegexUtils.escapeRegExp).join("|");
    const regex = new RegExp(`\\b(${pattern})\\b`, "gi");

    // String.split with a single capturing group places matches at odd indices, non-matches at even.
    return text.split(regex).map((part, i) =>
        i % 2 === 1 ? (
            <strong key={i} className="font-bold">
                {part}
            </strong>
        ) : (
            part
        )
    );
}
